package devxertech.com.pages.blogs

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import devxertech.com.seo.PageMetadataForCurrentRoute
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.pages.commons.CommonHeader
import devxertech.com.pages.dashboard.footerSection.HomepageFooter
import devxertech.com.pages.dashboard.ratingSection.RatingSection
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Res

@Page("/blogs")
@Composable
fun MainBlogs() {
    PageMetadataForCurrentRoute()
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()


    Column(
        modifier = Modifier.fillMaxSize().backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
    ) {
        CommonHeader(
            image =   Res.Image.blog_header,
            imageAlt = "Technology and digital media illustration",
            breakpoint = breakpoint,
            mainHeadingAsH1 = true,
            headingText = "Explore Ideas Shaping the\n" +
                    "Digital World ",
            descriptionText = "Dive Into the Minds Behind the Machines ,Thoughtfully Written, Technically Driven"
        )
        BlogsDescription()
        RatingSection(breakpoint)
        HomepageFooter(breakpoint)

    }
}
